import { TProfileData } from "../types";

export const STORAGE_PROFILE = "STORAGE_LISTENER_IDENT";

export const EMPTY_PROFILE: TProfileData = {
  username: "",
  usertable: "",
  skip: false,
};

export const MODERATOR_VALUE = "Модератор";

export const MODERATOR_OPTIONS: string[] = [
  MODERATOR_VALUE,
  ...Array.from({ length: 30 }, (_, i) => String(i + 1)),
];
